import React from 'react';
import * as Yup from 'yup';
import styled from 'styled-components';
import { Formik, Form as FormikForm } from 'formik';
import { Box, Button, TextField } from '@material-ui/core';

export const StyledForm = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

interface JiraLoginCodeFormFields {
  code: string;
}

const validationSchema = Yup.object().shape({
  code: Yup.string().required('Verification code is required.')
});

export interface JiraLoginCodeFormProps {
  isLoading?: boolean;
  onSubmit?: (code: string) => void;
}

const JiraLoginCodeForm: React.FC<JiraLoginCodeFormProps> = (
  props: JiraLoginCodeFormProps
) => {
  const { isLoading, onSubmit } = props;

  const onFormSubmit = (values: JiraLoginCodeFormFields) => {
    onSubmit?.(values.code);
  };

  return (
    <Formik
      initialValues={{ code: '' } as JiraLoginCodeFormFields}
      validationSchema={validationSchema}
      validateOnBlur={true}
      onSubmit={onFormSubmit}
    >
      {({ values, errors, touched, handleChange, handleBlur }) => (
        <StyledForm>
          <div>
            <TextField
              variant='outlined'
              type='text'
              name='code'
              label='Verification Code'
              className='form-field'
              placeholder='Enter verification code'
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={isLoading}
              value={values.code}
              error={touched.code && !!errors.code}
              helperText={errors.code}
            />
          </div>

          <Box mt={2}>
            <Button
              type='submit'
              variant='contained'
              disableElevation
              disabled={Boolean(!values.code || isLoading || errors.code)}
            >
              Submit
            </Button>
          </Box>
        </StyledForm>
      )}
    </Formik>
  );
};

export default JiraLoginCodeForm;
